module.exports = __webpack_public_path__ + "static/media/LV.d24278f8.svg";